/**
 * 商家卷
 * @param {"normal"|"discount"|"exchange"} key normal-满减卷 discount-折扣卷 exchange-换购卷
 * @param {string} stock_name //代金卷批次
 * @param {"NORMAL"|"DISCOUNT"|"EXCHANGE"} stock_type // 商家卷类型
 * @param {string|number} value1 //值1 满减卷的优惠金额    折扣卷的折扣    换购卷的换购价
 * @param {number} value2 //值2 消费门槛    1-1000000000
 * @return {object} 返回 卷模板
 */
export const getBusifavorCouponInfo = function({
  key,
  stock_name,
  stock_type,
  value1,
  value2
}) {
  let data = {
    stock_name: "", //代金卷批次
    belong_merchant: "", //归属商户号1601011649
    goods_name: "全场通用，特价商品除外。", //商品适用范围
    stock_type: "", //批次类型
    out_request_no: "", //商户单据号（格式：商户id+日期+流水号）
    //核销规则
    coupon_use_rule: {
      coupon_available_time: {
        available_begin_time: new Date(), //开始
        available_end_time: new Date(), //截止
        available_day_after_receive: "", //卷生效后N天有效-N
        wait_days_after_receive: "", //日期区间内，用户领券后需等待x天开始生效。
        //固定周期内有效时间段
        available_week: {
          week_day: [], // 可用星期数 0-周日，1-周一
          //可用时间段
          available_day_time: [
            {
              begin_time: "",
              end_time: ""
            },
            {
              begin_time: "",
              end_time: ""
            }
          ] // 当天可用时间段 最多填俩
        },
        //无规律的有效时间
        irregulary_avaliable_time: [
          { begin_time: "", end_time: "" },
          { begin_time: "", end_time: "" },
          { begin_time: "", end_time: "" }
        ]
      },
      //核销方式 OFF_LINE 线下扫码核销
      //MINI_PROGRAMS 线上小程序核销 需要传入
      /**
       * @property {"OFF_LINE"|"MINI_PROGAMS"|"PAYMENT_CODE"} use_method  OFF_LINE-线下滴码核销，点击券“立即使用”跳转展示券二维码详情。MINI_PROGRAMS-线上小程序核销 （需要添加小程序appid和path）。 PAYMENT_CODE-微信支付付款码核销，点击券“立即使用”跳转至微信支付钱包付款码。
       */
      use_method: "",
      mini_programs_appid: "",
      mini_programs_path: ""
    },
    //发放规则
    stock_send_rule: {
      max_coupons: 1000, //最大发放个数 取值范围 1 ≤ value ≤ 1000000000
      max_coupons_per_user: 1, //用户最大可领数 max-100,
      max_coupons_by_day: 1000000000, //单天发放上限个数
      natural_person_limit: true, //是否开启自然人限制
      prevent_api_abuse: true //可疑账号拦截
    },
    coupon_code_mode: "MERCHANT_API" //券code模式
  };
  switch (key) {
    case "normal": //固定金额满减
      data.stock_name = stock_name ? stock_name : "固定面额满减卷批次";
      data.stock_type = stock_type ? stock_type : "NORMAL";
      data.coupon_use_rule.fixed_normal_coupon = {
        discount_amount: value1, //优惠金额
        transaction_minimum: value2 //消费门槛
      };
      break;
    case "discount": //折扣卷
      data.stock_name = stock_name ? stock_name : "折扣券批次";
      data.stock_type = stock_type ? stock_type : "DISCOUNT";
      data.coupon_use_rule.discount_coupon = {
        discount_percent: value1, //折扣比例
        transaction_minimum: value2 //消费门槛
      };
      break;
    case "exchange":
      data.stock_name = stock_name ? stock_name : "换购券批次";
      data.stock_type = stock_type ? stock_type : "EXCHANGE";
      data.coupon_use_rule.exchange_coupon = {
        exchange_price: value1, //换购价
        transaction_minimum: value2 //消费门槛
      };
      break;
  }
  // console.log("商家卷--------------", data);
  return data;
};

/**
 * 现金卷 "voucher"
 * @param {number} value2 //值2 消费门槛    1-1000000000
 * @return {object} 返回 卷模板
 */
export const getNormalCouponInfo = function({ stock_name, value1, value2 }) {
  let data = {
    stock_name: stock_name ? stock_name : "固定面额满减卷批次", //代金卷批次
    belong_merchant: "", //归属商户号1601011649
    available_begin_time: new Date(), //开始
    available_end_time: new Date(new Date() - 90), //截止
    no_cash: true, //营销经费。枚举值：true：免充值 false：预充值
    /* 1、免充值：制券方无需提前充值资金，用户核销代金券时，直接从订单原价中扣除优惠减价金额，最终只将用户实际支付的金额结算给核销商户，商户实收少于订单原价。
  2、预充值：制券方需将优惠预算提前充值到微信支付商户可用余额中，用户核销代金券时，系统从制券方商户可用余额中扣除优惠减价部分对应的资金，连同用户实际支付的资金，一并结算给核销商户，不影响实收。 */
    stock_type: "NORMAL", //批次类型
    combine_use: "", //是否可叠加其他优惠卷
    available_items: [], //可用商品
    unavailable_items: [], //不可用商品

    out_request_no: "", //商户单据号（格式：商户id+日期+流水号）
    stock_use_rule: {
      //使用批次规则
      max_coupons: "", //发放上线
      max_amount: "", //发放总预算
      max_coupons_per_user: "", //单个用户可领个数
      natural_person_limit: true, //是否开启自然人限制
      prevent_api_abuse: true //是否开启防刷拦截
    },
    coupon_use_rule: {
      //核销规则满减卷使用规则
      fixed_normal_coupon: {
        coupon_amount: value1, //面额 x>1 && x<500
        transaction_minimum: value2 //使用门槛必须大于优惠金额
      },
      available_merchants: [] /* 可用商户的交易才可核销/使用代金券。当营销经费no_cash=false时，可用商户允许填入任何类型的特约商户或普通商户
        当营销经费no_cash=true时，分为以下几种情况：
        1、创建商户是普通商户或服务商特约商户(子商户)：可添加本商户号或同品牌商户。
        说明：若可用商户中，有特约商户(子商户)，那么特约商户自己发起的交易、以及服务商帮特约商户发起的交易，都可以使用代金券。
        2、创建商户是普通服务商：可添加已授权的子商户，详见《申请免充值代金券产品权限》。
        说明：特约商户如果有多个服务商，那么服务商为他发起的交易，只要完成了免充值授权，都可以使用代金券；特约商户自己发起的交易不可以使用代金券。
        3、创建商户是渠道商、银行服务商或从业机构：可直接添加旗下任意子商户，不需要子商户授权。
        校验规则：条目个数限制为【1，50】
        示例值：['9856000','9856111'] */
    }
  };

  // console.log("normal 现金折扣卷", data);
  return data;
};
